import { formatBytesSize, transformBToMB } from '../../../../utils/fileUtil';
import { FileUploadHeaderTemplateOptions } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';

type FileInputHeaderProps = {
  headerOptions: FileUploadHeaderTemplateOptions;
  currentSize: number;
  sizeLimitLabel: string;
  sizelimit: number;
};

const FileInputHeader = ({
  headerOptions,
  currentSize,
  sizeLimitLabel,
  sizelimit,
}: FileInputHeaderProps) => {
  const { className, chooseButton, uploadButton, cancelButton } = headerOptions;
  const value = (currentSize * 100) / sizelimit;

  let displayValue = currentSize;
  if (currentSize >= 1000000) {
    displayValue = transformBToMB(currentSize) * 1000000;
  }

  const formatedValue = formatBytesSize(displayValue);

  return (
    <div
      className={`${className} flex flex-wrap row-gap-3 column-gap-1`}
      style={{
        backgroundColor: 'transparent',
        alignItems: 'center',
      }}
    >
      {chooseButton}
      {uploadButton}
      {cancelButton}
      <div className="flex align-items-center gap-3 ml-auto mr-auto sm:mr-0">
        <span>
          {formatedValue} / {sizeLimitLabel}
        </span>
        <ProgressBar
          value={value}
          showValue={false}
          style={{ width: '10rem', height: '12px' }}
        />
      </div>
    </div>
  );
};

export default FileInputHeader;
